import { energySavingsApiSlice } from "../apiSlice";

const getBuildingIdString = (buildingsIdArray) => {
    const defaultString = 'building_ids='
    let buildingString = ''

    for(let i = 0 ; i < buildingsIdArray?.length; i++){
        if(i != 0){
            buildingString +='&'
        }

        buildingString += defaultString+ buildingsIdArray[i]
        
    }

    return buildingString
}

export const extractCachedEnergySavingsApiSlice = energySavingsApiSlice.injectEndpoints({
    tagTypes:  ["EnergySaving"],
    endpoints: builder => ({
        getCalculatedEnergySaving: builder.query({
            query: (args) => {
                const {buildingsIdArray, startDate, endDate, accountId} = args
                let accountString ="", buildingIdString =""
                if(accountId){
                    accountString = "&account_id=" + accountId
                }
                if(buildingsIdArray?.length > 0){
                    buildingIdString = getBuildingIdString(buildingsIdArray)
                }
                return{
                    url: `/calculate_energy_savings?${buildingIdString}${accountString}&start=${startDate}&end=${endDate}`
                }
            },
            providesTag: ["EnergySaving"],
        }),
        getExtractCachedEnergySaving: builder.query({
            query: (args) => {
               
                const {buildingsIdArray} = args
                const buildingIdString = getBuildingIdString(buildingsIdArray)
                return{
                    url:`/extract_cached_energy_savings?${buildingIdString}`
                }
            },
            providesTag: ["EnergySaving"],
        }), 
   
    })
})

export const {
    useGetCalculatedEnergySavingQuery,
    useLazyGetCalculatedEnergySavingQuery,
    useGetExtractCachedEnergySavingQuery,
    useLazyGetExtractCachedEnergySavingQuery,
} = energySavingsApiSlice